<template>
  <div class="content">
    <el-tabs class="tabLv3 " type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 操作记录
        </span>
        <div class="normalNav zaddBtn">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
        </div>
        <div class="searchForm1 alarmSearchForm">
          <el-form :class="className">
            <el-form-item label="开始时间">
              <el-date-picker
                v-model="searchForm.startTime"
                type="datetime"
                placeholder="请选择"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间">
              <el-date-picker
                v-model="searchForm.endTime"
                type="datetime"
                placeholder="请选择"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
          </el-form>
        </div>

        <div class="tableWrapper" v-loading="!showTable">
          <!-- 后端分页 -->
          <el-table :data="tableData" class="stripeTable" stripe>
            <el-table-column show-overflow-tooltip label="操作人员" prop="dealUserName">
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="控制类型"
              prop="controlTypeName"
            ></el-table-column>
            <el-table-column show-overflow-tooltip label="控制设备" prop="deviceName">
              <template slot-scope="scope">
                <span v-if="scope.row.actionType == 0">{{ scope.row.deviceName }}</span>
                <span v-else>{{ scope.row.devicePartsName }}</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="指令名称" prop="actionName">
            </el-table-column>
            <el-table-column show-overflow-tooltip label="请求信息" prop="actionReq">
            </el-table-column>
            <el-table-column show-overflow-tooltip label="响应信息" prop="actionResp">
            </el-table-column>
            <el-table-column show-overflow-tooltip label="记录时间" prop="create_time">
            </el-table-column>
          </el-table>
          <div class="footer">
            <el-pagination
              layout="prev, pager, next"
              :page-size="10"
              :current-page.sync="currentPage"
              @current-change="handleCurrentChange"
              :total="nTotal"
            >
            </el-pagination>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        className: 'collapse',
        tabName: 'jsgl',
        searchForm: {
          startTime: '',
          endTime: ''
        },
        showTable: true,
        //前端分页
        data: {},
        pagesize: 10,
        currentPage: 1,
        nTotal: 0,
        tableData: []
      }
    },
    methods: {
      refreshData() {
        this.currentPage = 1
        this.getInfoData()
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.getInfoData()
      },
      getInfoData() {
        this.$axiospost('operation/device/action/record/queryList', {
          ...this.searchForm,
          pageIndex: this.currentPage,
          pageSize: this.pagesize
        }).then(res => {
          this.tableData = res.data.data.list
          this.nTotal = res.data.data.total
        })
      },
      reset() {
        this.searchForm = {
          companyId: '',
          startTime: '',
          endTime: ''
        }
        this.pageNum = 1
      },
      subSeefrom() {
        if (this.searchForm.startTime != null && this.searchForm.endTime != null) {
          if (new Date(this.searchForm.startTime) >= new Date(this.searchForm.endTime)) {
            this.$message.error('开始时间不能晚于结束时间')
            return
          }
        }
        this.currentPage = 1
        this.getInfoData()
      }
    },
    components: {
      searchForm: () => import('public/searchForm')
    },
    mounted() {
      this.getInfoData()
    }
  }
</script>

<style lang="less" scoped>
  .alarmSearchForm {
    .el-form {
      /deep/ .el-form-item__label {
        width: 123px !important;
      }
    }

    .el-date-editor.el-input {
      width: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/actionRecord/index.vue